// Customer edit component for non-admin users
import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import EventCategoriesEditor from './eventCategoriesEditor';
import HonorarServiceAccountsEditor from './honorarServiceAccountsEditor';
import InvoiceNumberEditor from './invoiceNumberEditor';

@withText(props => ({
    customerNumber: <Text id='input.customerNumber-help'>customerNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class CustomerEdit extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('customer'),
        };
    }

    createCustomer = async () => {
        const { callback = () => {} } = this.props;
        const { customerStore } = this.props.stores;
        const { newCustomer } = customerStore;
        const response = await customerStore.adminCreate(newCustomer);
        if (response.status === 201) {
            callback();
        }
    }

    async componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { customerStore, fikenStore } = this.props.stores;
        if (!isNew) {
            if (idx >= 0) {
                customerStore.adminSetFromIdx(idx);
            } else if (id) {
                await customerStore.load(id);
            }
        }
        // Fetch Fiken bank accounts if Fiken is connected
        try {
            const customer = isNew ? customerStore.newCustomer : customerStore.customer;
            const fikenSlug = customer.fikenSlug;
            if (fikenSlug) {
                const response = await fikenStore.getBankAccounts(fikenSlug);
                if (response?.status === 200) {
                    customerStore.updateKeyValue('fikenBankAccounts', response.data || []);
                }
            }
        } catch (e) {
            // Silent failure - fields degrade to plain text inputs
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, customerStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newCustomer, customer } = customerStore;
        const editCustomer = isNew ? newCustomer : customer;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='customer.new'>New customer</Text> : <Text id='customer.edit'>Edit customer</Text>}
                    </div>
                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                fields={[
                                    'name',
                                    'orgNumber',
                                    'address',
                                    'postalcode',
                                    'place',
                                    'country',
                                    'phone',
                                    'fax',
                                    'email',
                                    'url',
                                    'facebook',
                                    'instagram',
                                    'images',
                                    'emailSender',
                                    'smsSender',
                                    'smsBookingSmsDaysBefore',
                                    'smsNotificationDaysBefore',
                                    'notificationEmailEnabled',
                                    'notificationEmailOnly',
                                    'smsTextBooking',
                                    'smsTextNotification',
                                    'departments',
                                    'workSharing',
                                    'shareProductDatabase',
                                    'invoiceAccount',
                                    'invoiceIban',
                                    'invoiceBic',
                                    'invoiceInfo',
                                    'invoiceDueDays',
                                    'accountingLockedUntil',
                                    'invoiceHidePaymentReference',
                                    'invoicePaymentReferenceText',
                                    'invoiceHeaderText',
                                    'invoiceFooterText',

                                    'collectiveInvoiceFeeEnabled',
                                    'collectiveInvoiceFee',
                                    'collectiveInvoiceFeeAccount',
                                    'collectiveInvoiceFeeName',
                                    'collectiveInvoiceFeeVat',

                                    'segmentAccountsEnabled',
                                    'segmentAccountFee',
                                    'segmentAccountMedicine',
                                    'segmentAccountEquipment',
                                    'segmentAccountOther',

                                    'calendarStartHour',
                                    'calendarEndHour',
                                    'calendarDays.monday',
                                    'calendarDays.tuesday',
                                    'calendarDays.wednesday',
                                    'calendarDays.thursday',
                                    'calendarDays.friday',
                                    'calendarDays.saturday',
                                    'calendarDays.sunday',

                                    'fikenSlug',
                                    'notVatRegistered',
                                    'fikenPaymentMethodCash',
                                    'fikenPaymentMethodCard',
                                    'fikenPaymentMethodCardApp',
                                    'fikenPaymentMethodCreditCard',
                                    'fikenPaymentMethodVipps',
                                    'fikenPaymentMethodGiftCard',
                                    'fikenPaymentMethodCustomerCredit',
                                    'fikenPaymentMethodAccount',
                                    'fikenPaymentMethodInvoice',
                                    'fikenPaymentMethodPayPal',
                                    'fikenPaymentMethodConvene',
                                    'fikenPaymentMethodCreditNote',
                                    'fikenPaymentMethodInsurance',
                                    'fikenRoundingAccount',
                                    'featureFlags.oreRoundingCashOnly',
                                    'featureFlags.insurancePaidSaleOnCompany',
                                    'featureFlags.insuranceSettlementPaymentMethod',
                                    'fikenAccessToken',

                                    'paymentMethodCash',
                                    'paymentMethodCard',
                                    'paymentMethodCardApp',
                                    'paymentMethodCreditCard',
                                    'paymentMethodVipps',
                                    'paymentMethodGiftCard',
                                    'paymentMethodCustomerCredit',
                                    'paymentMethodAccount',
                                    'paymentMethodInvoice',
                                    'paymentMethodPayPal',
                                    'paymentMethodConvene',
                                    'paymentMethodInsurance',
                                    'agriaAgentNumber',
                                    'paymentMethodCreditNote',
                                    'tripletexEmployeeToken',
                                    'duettClientId',
                                    'tripletexSendInvoiceToCustomer',
                                    'tripletexAttachInvoicePdf',

                                    'powerOfficeSendInvoiceToCustomer',
                                    'fikenSendInvoiceToCustomer',

                                    'netsUsername',
                                    'netsPassword',
                                    'netsTerminals',
                                    'transferCutoffDate',
                                    // 'dyreIdClinicId',

                                    'journalItems.generalCondition',
                                    'journalItems.physicalExaminationFindings',
                                    'journalItems.diagnosticTests',
                                    'journalItems.diagnosis',
                                    'journalItems.treatmentPlan',
                                    'journalItems.medicines',
                                    'journalItems.medicine',
                                    'journalItems.diagnoses',
                                    'journalItems.description',
                                    'journalItems.clientCommunication',
                                    'journalItems.recommendations',
                                    'journalItems.followUp',
                                    'journalItems.puls',
                                    'journalItems.respiration',
                                    'journalItems.temperature',

                                    'featureFlags.newsletterUnsubscribed',
                                    'featureFlags.halloweenDecoration',
                                    'featureFlags.hideNativeAppPurchases',
                                    'featureFlags.cardExternalTerminal',
                                    'featureFlags.cashCarryForward',
                                    'featureFlags.useFormFieldsCompact',
                                    'featureFlags.pricesExclMva',
                                    'featureFlags.calendarOffDutyColor',
                                    'featureFlags.hideCalendarPopupPreview',
                                    'featureFlags.hideCalendarInEventEditor',
                                    'featureFlags.showCalendarWhenEditEvent',
                                    'featureFlags.calendarHourHeight',
                                    'featureFlags.calendarTodosWeekMonth',
                                    'featureFlags.discountType',
                                    'featureFlags.discountFeeOnly',
                                    'featureFlags.discountLineAmount',
                                    'featureFlags.productPackaging',
                                    'featureFlags.receiptSpacing',
                                    'featureFlags.showVetOnInvoice',
                                    'featureFlags.productionCompact',
                                    'featureFlags.saleDateTop',
                                    'featureFlags.enableOfflinePrefetch',
                                    'featureFlags.allowJournalWhenPaid',
                                    'featureFlags.autoCreateJournal',
                                    'featureFlags.journalFeedback',
                                    'featureFlags.autoAddMedicineAsProduct',
                                    'featureFlags.autoAddJournalMedicineAsProducts',
                                    'featureFlags.autoAddPrescriptionProduct',
                                    'featureFlags.onlinePrescriptionOrders',
                                    'featureFlags.copyPriceLinesOnJournalCopy',
                                    'featureFlags.audioTranscribe',
                                    'featureFlags.isVetFamilyMember',
                                    'featureFlags.dyreIdReport',
                                    'featureFlags.preventEmailInvoice',
                                    'featureFlags.invoiceAdminOnly',
                                    'featureFlags.allowEmailInvoiceWithAccounting',
                                    'featureFlags.hideOtherCustomerTickets',
                                    'featureFlags.sharedSales',
                                    'featureFlags.tripletexVoucher',
                                    'featureFlags.tripletexVoucherPeriod',
                                    'featureFlags.tripletexVoucherRoundingAccount',
                                    'featureFlags.tripletexVoucherSendToLedger',
                                    'featureFlags.tripletexVoucherAutoPost',
                                    'featureFlags.tripletexAutoSyncPayments',
                                    'featureFlags.duettVoucher',
                                    'featureFlags.duettVoucherPeriod',
                                    'featureFlags.duettAutoSyncPayments',
                                    'featureFlags.powerOfficeAutoSyncPayments',
                                    'featureFlags.fikenAutoSyncPayments',
                                    'featureFlags.criticalTasks',
                                    'featureFlags.peopleAtWork',
                                    'featureFlags.weeklyChecklist',
                                    'featureFlags.customerCredit',
                                    'featureFlags.smsOnOnlineBooking',
                                    'featureFlags.onlineBookingSelfRegister',
                                    'featureFlags.onlineBookingRequireAddress',
                                    'featureFlags.smsOnSelfRegister',
                                    'featureFlags.emailOnSelfRegister',
                                    'featureFlags.idexx',
                                    'featureFlags.idexxPimsId',
                                    'featureFlags.idexxEnvironment',
                                    'featureFlags.kpiDashboard',
                                    'featureFlags.onThisDay',
                                    'featureFlags.faceRecognition',
                                    'featureFlags.lockScreen.enabled',
                                    'featureFlags.lockScreen.softLockMinutes',
                                    'featureFlags.lockScreen.hardLogoutHours',
                                ]}
                                holdingStore={customerStore}
                                objectName={isNew ? 'newCustomer' : 'customer'}
                                isNew={isNew}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                            />
                            {editCustomer && editCustomer.id > 0 && (
                                <InvoiceNumberEditor
                                    stores={this.props.stores}
                                    customerId={editCustomer.id}
                                    isAdmin={isAdmin}
                                />
                            )}
                            <div class='mt-3'>
                                <HonorarServiceAccountsEditor
                                    stores={this.props.stores}
                                    isNew={isNew}
                                />
                            </div>
                            <div class='mt-3'>
                                <EventCategoriesEditor
                                    stores={this.props.stores}
                                    isNew={isNew}
                                />
                            </div>
                        </div>

                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createCustomer}>
                            {isNew ? <Text id='customer.create'>Create customer</Text> : <Text id='customer.save'>Save customer</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default CustomerEdit;
